import { render, staticRenderFns } from "./SampleAnalyteTable.vue?vue&type=template&id=64e65016"
import script from "./SampleAnalyteTable.vue?vue&type=script&lang=js"
export * from "./SampleAnalyteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports